import { useState, useEffect, useCallback } from "react";
import { IThuaDatIdentity, IChiTietThuaDat, IDisplayGeo } from "../_types_";
import { getPriceHistory, calculatePrice } from "../apis/giadat.api";

export function useHistory(thuaDat: IThuaDatIdentity | undefined) {
  const [history, setHistory] = useState<IChiTietThuaDat>();

  const getHistory = useCallback(async () => {
    if (thuaDat) {
      try {
        let chiTiet = await getPriceHistory(
          thuaDat.maHuyen,
          thuaDat.maXa,
          thuaDat.soTo.toString(),
          thuaDat.soThua.toString()
        );
        setHistory(chiTiet);
      } catch (er) {
        setHistory(undefined);
      }
    }
  }, [thuaDat]);

  useEffect(() => {
    getHistory().catch((e) => {
      console.log(e);
    });
    return () => {};
  }, [getHistory, thuaDat]);

  return [history, getHistory] as const;
}

export function useCalculatePrice(thuaDat: IThuaDatIdentity | undefined) {
  const [giaDat, setGiaDat] = useState<IChiTietThuaDat>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getGiaDat = useCallback(async () => {
    setIsLoading(true);
    if (thuaDat) {
      try {
        let chiTiet = await calculatePrice(
          thuaDat.maHuyen,
          thuaDat.maXa,
          thuaDat.soTo,
          thuaDat.soThua
        );
        setGiaDat(chiTiet);
      } catch (er) {
        setGiaDat(undefined);
      }
    }
    setIsLoading(false);
  }, [thuaDat]);

  useEffect(() => {
    getGiaDat();
  }, [getGiaDat]);

  return { giaDat, isLoading };
}

export function useSelectedGeometries(thuaDat: IThuaDatIdentity | undefined) {
  const [geometries, setGeometries] = useState<IDisplayGeo[]>([]);
  const setSelectedGeometries = (data: IDisplayGeo[]) => {
    setGeometries(data);
  };

  return [geometries, setSelectedGeometries] as const;
}
